import productPageDemo from "@/assets/product-page-demo.png";

const ConversionSection = () => {
  return (
    <section className="w-full py-16 md:py-24 bg-background">
      <div className="mx-auto max-w-7xl px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left - Content */}
          <div className="space-y-6">
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-normal text-foreground leading-tight">
              Your page has never converted so much.
            </h2>
            <p className="text-lg md:text-xl text-muted-foreground leading-relaxed">
              AI-optimized product pages that turn browsers into buyers, engineered to maximize conversions.
            </p>
            <ul className="space-y-4 text-muted-foreground">
              <li className="flex items-start gap-3">
                <span className="w-1.5 h-1.5 rounded-full bg-blue-600 mt-2.5 flex-shrink-0" />
                <span>Persuasive copy that speaks to customer pain points</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-1.5 h-1.5 rounded-full bg-blue-600 mt-2.5 flex-shrink-0" />
                <span>Strategic placement of social proof and trust signals</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-1.5 h-1.5 rounded-full bg-blue-600 mt-2.5 flex-shrink-0" />
                <span>Optimized layouts tested across thousands of stores</span>
              </li>
            </ul>
          </div>

          {/* Right - Image */}
          <div className="lg:order-last">
            <img
              src={productPageDemo}
              alt="High-converting product page example"
              loading="lazy"
              decoding="async"
              className="w-full h-auto"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ConversionSection;
